import React from 'react'
import {
  ListGroup as BsListGroup,
  ListGroupItemProps,
  ListGroupProps,
} from 'react-bootstrap'

interface IListGroup extends Partial<ListGroupProps> {
  children?: React.ReactNode
  flush?: boolean
}

type TExtraProps = {
  variant?: 'flush'
}

interface TItem extends ListGroupItemProps {
  noMargin?: boolean
}

type newStyle = {
  padding?: number | string
}
const ListGroup = (props: IListGroup): React.ReactElement => {
  const { children, flush, ...rest } = props

  const extraProps: TExtraProps = {}

  if (flush) {
    extraProps.variant = 'flush'
  }

  return (
    <BsListGroup {...extraProps} {...rest}>
      {children}
    </BsListGroup>
  )
}

export const Item = (props: TItem): React.ReactElement => {
  const { noMargin, style = {}, ...rest } = props
  const newStyle: newStyle = style
  if (noMargin) {
    newStyle.padding = '0' // "-0.75rem -1.25rem"
  }
  return <BsListGroup.Item {...rest} style={newStyle} />
}

export default ListGroup

export const ListGroupItem = Item
